<div class="well">
    <form [formGroup]="form">
        <h2>Search for Service History</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-3 col-lg-2 mvd_form-group">
                    <label>Start Date</label>
                    <p-calendar placeholder="mm/dd/yyyy" formControlName="startDate" [showIcon]="true" [maxDate]="maxStartDate" (onSelect)="onStartDateChanged($event)" dateFormat="mm/dd/yy"></p-calendar>
                    <control-validation-messages control="startDate"></control-validation-messages>
                    <div class="mvd_alert__validation" *ngIf="form.hasError('startAfterEndDate')">
                        <div class="mvd_alert__rule">Start date cannot be after End date</div>
                    </div>
                </div>
                <div class="col-sm-3 col-lg-2 mvd_form-group">
                    <label>End Date</label>
                    <p-calendar placeholder="mm/dd/yyyy" formControlName="endDate" [showIcon]="true" [maxDate]="maxEndDate" dateFormat="mm/dd/yy"></p-calendar>
                    <control-validation-messages control="endDate"></control-validation-messages>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-8 col-md-5 mvd_form-group">
                    <label for="businessUnitId">Business Unit</label>
                    <p-dropdown [options]="businessUnits" formControlName="businessUnitId" filter="filter"></p-dropdown>
                </div>
                <div class="col-sm-8 col-md-4 mvd_form-group">
                    <label for="businessTransactionTypeId">Business Transaction Type</label>
                    <p-dropdown [options]="businessTransactionTypes" formControlName="businessTransactionTypeId" filter="filter"></p-dropdown>
                </div>
                <div class="mvd_form-txt">
                    Or
                </div>
                <div class="col-sm-3 col-md-2 mvd_form-group">
                    <label for="receiptId">Receipt #</label>
                    <input class="mvd_form-control" id="receiptId" type="number" autocomplete="off" formControlName="receiptId" />
                    <control-validation-messages control="receiptId"></control-validation-messages>
                </div>
            </div>
        </fieldset>
        <div class="well__footer">
            <div class="btn--group">
                <button type="button" class="btn--default" (click)="resetSearch()" [disabled]="inProgress">Reset</button>
                <button type="submit" class="btn--primary" (click)="search()" [disabled]="inProgress">Find</button>
            </div>
        </div>
    </form>
    <div class="divider">
        <service-history-results #serviceHistoryResults [searchCriteria]="form.value"></service-history-results>
    </div>
</div>
